import axiosInstance from '../../../../config/axiosInstance';
import { UserValidation } from "../../views/User/Validation/UserValidation";

const handleChange = (event, formData, setFormData) => {
  const { name, value } = event.target;
  setFormData({
    ...formData,
    [name]: value,
  });
};

const handleSubmit = async (event, formData, setFormData, setErrors,selectedUsers) => {
    event.preventDefault();

   
        try {
            const CompanyID = localStorage.getItem("CompanyID");
            const UserID = localStorage.getItem("UserID");

            // Create a FormData object
            const formDataToSend = new FormData();

            // Append form data fields
            formDataToSend.append('ClientID', CompanyID);
          //  formDataToSend.append('UserID', UserID);

            // Append other fields from formData
            Object.keys(formData).forEach(key => {
                if (key !== 'File') { // Skip the File key, we will handle it separately
                    formDataToSend.append(key, formData[key]);
                }
            });
            if (formData.File) {
                formDataToSend.append('File', formData.File);
            }
            debugger;
            if (selectedUsers && selectedUsers.length > 0) {
                formDataToSend.append('UserList', JSON.stringify(selectedUsers));
            }
            const config = {
                headers: {                    
                    'Content-Type': 'multipart/form-data'
                }
            };            
            const response = await axiosInstance.post(`/Setup/UpdateUserProfile`, formDataToSend, config);
            return response.data;
          
        } catch (error) {
            console.error('Error posting data:', error);
        }
    
};


export { handleChange, handleSubmit };
